import React from 'react';
import usePauseEditorFocusWhileComponentRendered from '../../../boardsPage/editing/usePauseEditorFocusWhileComponentRendered';
import TiptapTextStylePopupContent from '../../../../workspace/toolbar/components/selectionTools/editorTools/textStylePopup/TiptapTextStylePopupContent';
import { prop } from '../../../../../common/utils/immutableHelper';
import { MobileTextStyleRichTextToolProps } from './MobileTextStyleRichTextTool';
import { ElementType } from '../../../../../common/elements/elementTypes';
import { DOCUMENT_MODAL_EDITOR_KEY } from '../../../../element/document/modal/documentModalConstants';

const MobileTextStyleSheetContent = (props: MobileTextStyleRichTextToolProps) => {
    const { editorKey } = props;

    usePauseEditorFocusWhileComponentRendered();
    const element = prop(0, props.selectedElements);

    const showBlockStyleTools = editorKey === ElementType.CARD_TYPE || editorKey === DOCUMENT_MODAL_EDITOR_KEY;

    return <TiptapTextStylePopupContent {...props} showBlockStyleTools={showBlockStyleTools} element={element} />;
};

export default MobileTextStyleSheetContent;
